<div
  class="d-flex flex-wrap flex-column flex-md-row justify-content-between"
  *ngIf="availableChars"
>
  <span
    class="text-primary h3 fw-bold text-decoration-none disabled p-2"
    [ngClass]="{ active: character.toLowerCase() === selectedCharacter, disabled: !availableChars.includes(character.toLowerCase())}"
    *ngFor="let character of alphabet"
    (click)="characterSelectionHandler(character.toLowerCase())"
  >
    {{ character }}
  </span>
</div>
